// extracted by mini-css-extract-plugin
module.exports = {"container":"structure_container__1AGMV","content":"structure_content__2xSUu","leftPanel":"structure_leftPanel__1OnaF","rightSection":"structure_rightSection__SQdZP"};